// @ts-strict-ignore
import { Button, Flex, mediaQuery, Text } from "@hubble/web";
import styled from "styled-components";

export const BannerNashvillePromoContainer = styled.section`
  margin-bottom: 6rem;
  @media ${mediaQuery.mobileXsDown} {
    margin-bottom: 0rem;
  }
`;

export const BannerNashvillePromoContent = styled(Flex)`
  padding: 3rem 1rem;
  gap: 2rem;
  align-items: center;
  @media ${mediaQuery.mobileXsDown} {
    align-items: flex-start;
    padding: 3rem 0 1rem;
  }
` as typeof Flex;

export const TextContentContainer = styled(Flex)`
  align-items: center;

  @media ${mediaQuery.mobileXsDown} {
    align-items: flex-start;
    margin-left: 2.5rem;
  }
` as typeof Flex;

export const Title = styled(Text.Display)`
  max-width: 450px;
  margin: 0 auto 1rem;
  line-height: 81px !important;
  letter-spacing: -6px !important;
  span {
    background: linear-gradient(180deg, #ff8e00 53.66%, #fc4848 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media ${mediaQuery.tabletMdDown} {
    line-height: 1 !important;
    letter-spacing: -1px !important;
  }

  @media ${mediaQuery.mobileXsDown} {
    letter-spacing: -3px !important;
    line-height: 54px !important;
    font-family: "Geist", sans-serif;
    font-size: 64px !important;
    font-weight: 700;
    max-width: 100%;
  }
` as typeof Text.Display;

export const Subtitle = styled(Text.Heading)`
  span {
    color: #ff7c05;
  }
` as typeof Text.Heading;

export const BrandButton = styled(Button.Brand)`
  width: max-content;
` as typeof Button.Brand;

export const PrimaryButton = styled(Button.Primary)`
  width: max-content;
` as typeof Button.Primary;

export const BannerImageWrapper = styled.div`
  text-align: center;

  @media ${mediaQuery.mobileXsDown} {
    margin-left: 1.5rem;
  }
`;
